import { css, Interpolation, Theme } from '@emotion/react'
import { ReactNode } from 'react'

const titleStyle = (t: Theme) => css`
  font-family: 'Noto Sans', sans-serif;
  font-size: 2rem;
  font-weight: 400;
  color: #333;
`
type Props = {
  children: ReactNode
  addStyle?: Interpolation<Theme>
}
export const MainTitle = ({ children, addStyle }: Props) => {
  return <h1 css={[titleStyle, addStyle]}>{children}</h1>
}
